<script>
    export let value;
    export let max;
</script>

<div>
    {#each Array(max) as _, i}
        {#if i + 1 <= value }
            <div class="circle filled"></div>
        {:else}
            <div class="circle"></div>
        {/if}
    {/each}
</div>


<style>
    .circle {
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        border: solid 1px #10284B;
        margin-right: 4px;
    }
    .filled {
        background: #10284B;
    }

</style>